<template>
     <div id="crashCommitVerificationDiv" v-if="crashMarkInitiated">
        <div id="crashFormModalOverlay">
        </div>
        <div id="crashMarkVerifyFormDiv">
            <div id="crashConfirmationSpinnerWrapper" v-if="crashCommitted" :class="[waitingForDeletion ? 'appear' : '']">
            </div>
            <div id="crashConfirmationSpinner" v-if="crashCommitted" :class="[waitingForDeletion ? 'appear' : '']">
            </div>
            <div id="crashMarkConfirmMessage">
                Would you like to remove 
                <br/>
                {{ crashedCar.StockNumber }} 
                <br/>
                {{ crashedCar.Year }} {{ crashedCar.Make }} {{ crashedCar.Model }} 
                <br/>
                from the database?
            </div>
            <div id="crashConfirmationActionDiv">
                <div id="crashMarkCancle" @click="closeCrashMarkingForm">
                    Cancel
                </div>
                <div id="confirmCrashedButton" @click="markAsCrashed">
                    CONFIRM REMOVE VEHICLE
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                crashCommitted: false
            }
        },
        computed: {
            crashMarkInitiated() {
                return this.$store.getters.hasCrashMarkBeenInitiated;
            },
            crashedCar() {
                return this.$store.getters.getCrashedVehicle;
            },
            waitingForDeletion() {
                return (this.crashMarkInitiated && this.crashCommitted);
            }
        },
        methods: {
            markAsCrashed() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('confirm', {'event_category': 'vehicle_removal','event_label': eventLabel});
                this.$store.dispatch('crashVehicle', this.crashedCar.VIN);
                this.crashCommitted = true;
            },
            closeCrashMarkingForm() {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('close_form', {'event_category': 'vehicle_removal','event_label': eventLabel});
                this.$store.commit('toggleCrashMarkInitiated', null);
            }
        }
    }
</script>

<style>
    #crashFormModalOverlay {
        height: calc(100 * var(--vh));
        width: calc(100 * var(--vw));
        top: 0;
        left: 0;
        background-color: black;
        opacity: .4;
        z-index: 10;
        position: absolute;
    }

    #crashMarkVerifyFormDiv {
        position: fixed;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        background: linear-gradient(#DFDFDF, #FFFFFF);
        border: solid #8291A0 thin;
        border-radius: 5px;
        color: #2c3e50;
        height: calc(40 * var(--vh));
        width: calc(40 * var(--vw));
        top: calc(30 * var(--vh));
        left: calc(30 * var(--vw));
        z-index: 12;
    }

    .inmobile #crashMarkVerifyFormDiv {
        height: calc(98 * var(--vh));
        width: calc(98 * var(--vw));
        top: calc(1 * var(--vh));
        left: calc(1 * var(--vw));
    }

    #crashMarkConfirmMessage {
        font-weight: bolder;
        font-size: 1.6em;
    }

    #crashConfirmationActionDiv {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }

    #crashMarkCancle {
        background-color: white;
        color: #2c3e50;
        border-radius: 0;
        width: fit-content;
        height: fit-content;
        font-size: calc(2 * var(--vh));
        font-weight: normal;
        margin: calc(1 * var(--vh));
        font-style: normal;
        font-weight: bold;
        cursor: pointer;
    }

    #confirmCrashedButton {
        background-color: var(--mccluskeyBlue);/*#0077C0;*//*#0079B6;*//*#AF873F;*/
        border-radius: 5px;
        width: calc(26 * var(--vw));
        height: calc(3.2 * var(--vh));
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: "myriad-pro", arial, sans-serif;
        font-weight: bold;
        color: white;
        font-size: calc(2.1 * var(--vh));/*calc(4.4 * var(--vw));*/
        margin: 0 calc(2 * var(--vw));
        border: solid white .75px;
    }

    .inmobile #confirmCrashedButton {
        width: calc(68 * var(--vw));
        min-width: fit-content;
    }
    
    #crashConfirmationSpinnerWrapper {
        position: absolute;
        height: inherit;
        width: inherit;
        background-color: black;
        z-index: 11;
        opacity: 0;
        transition: opacity 1s;
    }

    #crashConfirmationSpinnerWrapper.appear {
        opacity: .4;
    }

    #crashConfirmationSpinner {
        position: absolute;
        left: calc(25 * var(--vw));
        top: calc(30 * var(--vh));
        z-index: 2;
        width: 100px;
        height: 100px;
        margin: -75px 0 0 -75px;
        border: 6px solid rgb(172,179,183);
        border-radius: 50%;
        border-top: 6px solid var(--mccluskeyBlue); /*#0079B6;*/
        width: 45px;
        height: 45px;
        -webkit-animation: spin 3s linear infinite;
        animation: spin 3s linear infinite;
        opacity: 0;
        -webkit-transition: opacity 1s;
        -moz-transition: opacity 1s;     
        transition: opacity 1s;
    }

    .inmobile #crashConfirmationSpinner {
        left: calc(60 * var(--vw));
        top: calc(50 * var(--vh));
    }

    #crashConfirmationSpinner.appear {
        opacity: 1;
    }
    
    @-webkit-keyframes spin {
        0% { -webkit-transform: rotate(0deg); }
        100% { -webkit-transform: rotate(360deg); }
    }
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>